import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=4d61d7a3&scoped=true&"
import script from "./prize.vue?vue&type=script&lang=js&"
export * from "./prize.vue?vue&type=script&lang=js&"
import style0 from "./prize.vue?vue&type=style&index=0&id=4d61d7a3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d61d7a3",
  null
  
)

export default component.exports